import { render, staticRenderFns } from "./TreatmentOptions.vue?vue&type=template&id=fda1b686&scoped=true"
import script from "./TreatmentOptions.vue?vue&type=script&lang=js"
export * from "./TreatmentOptions.vue?vue&type=script&lang=js"
import style0 from "./TreatmentOptions.vue?vue&type=style&index=0&id=fda1b686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda1b686",
  null
  
)

export default component.exports